/* eslint-disable */
import {
  MVM_ALLIANCE_BATTLE_PANEL_BG_URL,
  MVM_ALLIANCE_BATTLE_PANEL_BOTTOM_URL,
  MVM_ALLIANCE_BATTLE_PANEL_TOP_URL,
  MVM_WORLD_MAP_ATTACK_STATUS_PANEL_BG_URL,
} from '../pages/hex-battle/constants'
import { getWorldMapTerrainEnginePreloadUrls } from '../game/world-map/terrial-engine/constants'
import { WORLD_MAP_MENU_V2_PRELOAD_URLS } from '../game/world-map/new-world-map-ui/worldMapMenuV2Assets'

const WM_REDESIGN =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/redesign/world-map'


/** Redesign world-map UI webp — keep in sync with Top/Bottom menu + left battle HUD. */
export const WORLD_MAP_REDESIGN_BLOB_PRELOAD_URLS: readonly string[] = [
  `${WM_REDESIGN}/world-map-bottom-panel-bg-left.webp`,
  `${WM_REDESIGN}/world-map-bottom-panel-bg.webp`,
  `${WM_REDESIGN}/world-map-bottom-panel-bg-right.webp`,
  `${WM_REDESIGN}/avatar-frame.webp`,
  `${WM_REDESIGN}/world-map-top-connector-sign.webp`,
  `${WM_REDESIGN}/mini-map-frame.webp`,
  `${WM_REDESIGN}/enter.webp`,
  `${WM_REDESIGN}/alliance.webp`,
  `${WM_REDESIGN}/spy.webp`,
  `${WM_REDESIGN}/diplomacy.webp`,
  `${WM_REDESIGN}/mail.webp`,
  `${WM_REDESIGN}/march.webp`,
  `${WM_REDESIGN}/alliance-battle.webp`,
]

/** MvM HUD blobs used on the world map (pending attacks + alliance slide panel). */
export const WORLD_MAP_MVM_PANEL_BLOB_PRELOAD_URLS: readonly string[] = [
  MVM_WORLD_MAP_ATTACK_STATUS_PANEL_BG_URL,
  MVM_ALLIANCE_BATTLE_PANEL_BG_URL,
  MVM_ALLIANCE_BATTLE_PANEL_TOP_URL,
  MVM_ALLIANCE_BATTLE_PANEL_BOTTOM_URL,
]

/** Top bar resource strip (matches `WorldMapTopMenu`). */
export const WORLD_MAP_EXTRA_BLOB_PRELOAD_URLS: readonly string[] = [
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/mining-factory/usdt-icon.webp',
]

/** Terrain / castle atlases from `terrial-engine/constants` + `castle-shield.webp` — warmed early (deduped in preload runner). */
export const WORLD_MAP_TERRAIN_ENGINE_PRELOAD_URLS: readonly string[] = getWorldMapTerrainEnginePreloadUrls()

export const WORLD_MAP_VERCEL_PRELOAD_URLS: readonly string[] = [
  ...WORLD_MAP_TERRAIN_ENGINE_PRELOAD_URLS,
  ...WORLD_MAP_REDESIGN_BLOB_PRELOAD_URLS,
  ...WORLD_MAP_MENU_V2_PRELOAD_URLS,
  ...WORLD_MAP_MVM_PANEL_BLOB_PRELOAD_URLS,
  ...WORLD_MAP_EXTRA_BLOB_PRELOAD_URLS,
]
